import { FormControl, ValidatorFn } from '@angular/forms';

import { Patterns } from '../personal-details.expressions';

/**
 * Validates whether the given insertion is allowed
 */
export class ApInsertionValidator {
    static createValidator(): ValidatorFn {
        return (control: FormControl) => this.insertionValidation(control.value);
    }
    static insertionValidation(value: string) {
        return Patterns.INSERTION_VALIDATION.test(value) ? { insertionAllowed: false } : null;
    }
}
